<!-- 
Takes text containing line breaks and displays it as a series of paragraphs.
-->
<template>
  <div v-if="text">
    <p v-if="!multiline" :class="{'mb-0':noMargin}">{{ text }}</p>
    <p v-else :class="{'mb-0':noMargin}">
      <span v-for="(line, index) in lines" :key="`line-${index}`">
        {{ line }}
        <br>
      </span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      validator: prop => typeof prop === "string" || prop === null,
      required: true
    },
    noMargin: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    multiline() {
      return this.lines.length > 1;
    },
    lines() {
      return this.text ? this.text.split("\n") : [];
    }
  }
};
</script>
